// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

//import { baseThemeSettings } from "../index"
//import unitless from "../../utils/unitless"

//const { rythm } = baseThemeSettings
const images = {
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 99999,
  },
}

export default images
